import { createFileRoute } from '@tanstack/react-router';
import { Lock } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import ChangePasswordForm from '@/components/features/user/forms/change-password-form';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { TabsContent } from '@/components/ui/tabs';

export const Route = createFileRoute('/_authenticated/user/edit/security')({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation();

  return (
    <TabsContent value="security">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center">
            <Lock className="mr-2 h-5 w-5 text-green-500" />
            {t('authenticated.user.edit.security.title')}
          </CardTitle>
          <CardDescription>
            {t('authenticated.user.edit.security.description')}
          </CardDescription>
        </CardHeader>
        <CardContent>
          <ChangePasswordForm>
            <ChangePasswordForm.Fields />
            <ChangePasswordForm.Actions />
          </ChangePasswordForm>
        </CardContent>
      </Card>
    </TabsContent>
  );
}
